import { useState, useEffect } from 'react';

/**
 * Хук для отслеживания загрузки изображения с плавным fade-эффектом
 * @param image - URL изображения
 * @returns isLoaded - флаг загрузки изображения
 */
export const useImageLoad = (image?: string): boolean => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!image) {
            setIsLoaded(false);

            return;
        }

        const img = new Image();
        img.src = image;

        // Если картинка уже в кэше, загружаем сразу
        if (img.complete && img.naturalHeight) {
            setIsLoaded(true);

            return;
        }

        img.onload = () => {
            setIsLoaded(true);
        };

        img.onerror = () => {
            setIsLoaded(false);
        };

        return () => {
            img.onload = null;
            img.onerror = null;
        };
    }, [image]);

    return isLoaded;
};
